/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model from "@ember-data/model";
import Store from "@ember-data/store";
import ModelRegistry from "@ember-data/types/registries/model";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import { getPrescriptionJournalEventComponent } from "core/components/prescription/utils/prescription-helpers";
import BioExamPrescribedJournalEvent from "core/models/bio-exam-prescribed-journal-event";
import FileUploadedJournalEvent from "core/models/file-uploaded-journal-event";
import JournalEvent from "core/models/journal-event";
import MedicalImagingPrescribedJournalEvent from "core/models/medical-imaging-prescribed-journal-event";
import MedicationPrescribedJournalEvent from "core/models/medication-prescribed-journal-event";
import NotificationTriggeredJournalEvent from "core/models/notification-triggered-journal-event";
import ParamedicalCarePrescribedJournalEvent from "core/models/paramedical-care-prescribed-journal-event";
import PatientChatMessageSentJournalEvent from "core/models/patient-chat-message-sent-journal-event";
import PrescriptionJournalEvent from "core/models/prescription-journal-event";
import SemeiaSessionService from "core/services/session";
import dayjs from "dayjs";
import { task } from "ember-concurrency";
import IntlService from "ember-intl/services/intl";
export const ChatMessageInterlocutor = {
  Sender: "sender",
  Recipient: "recipient",
  Recipient_Alternate: "recipient-alternate"
};
let ChatMessageFeedMessageComponent = (_class = class ChatMessageFeedMessageComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "store", _descriptor3, this);
    _defineProperty(this, "unreadMessage", _buildTask(() => ({
      context: this,
      generator: function* () {
        yield this.store.createRecord("notification-triggered-journal-event", {
          occurredAt: this.args.messageEvent.occurredAt,
          patient: this.args.messageEvent.patient,
          triggeringJournalEvent: this.args.messageEvent
        }).save();
      }
    }), null, "unreadMessage", null));
  }
  get message() {
    return this.args.messageEvent.body;
  }
  get creator() {
    return this.args.messageEvent.creator;
  }
  get creatorType() {
    return this.creator?.constructor?.modelName;
  }
  get isMessageSentByMedic() {
    return this.creatorType === "medic";
  }
  get isMessageSentByPatient() {
    return this.creatorType === "patient";
  }
  get interlocutorDisplayName() {
    if (this.interlocutorType === ChatMessageInterlocutor.Sender) {
      return this.intl.t("chat.interlocutors.sender");
    }
    if (this.isMessageSentByMedic) {
      const creator = this.creator;
      const prefix = creator.role === "doctor" ? this.intl.t("chat.interlocutors.doctor") + " " : "";
      return prefix + creator.fullName;
    } else if (this.isMessageSentByPatient) {
      return this.intl.t("chat.interlocutors.patient");
    }
    return this.intl.t("chat.interlocutors.program");
  }
  get signature() {
    return `${this.interlocutorDisplayName} le ${dayjs(this.args.messageEvent.occurredAt).format("DD/MM/YYYY à HH:mm")}`;
  }
  get triggeringJournalEvent() {
    return this.args.messageEvent.triggeringJournalEvent;
  }
  get isReadOnly() {
    return this.session.patient != null;
  }
  get callbackUrl() {
    const patientId = this.args.messageEvent.patient.get("id");
    return this.session.medic ? `/medics-web/patients/${patientId}/chat` : "/patient-web/chat";
  }
  get triggeringJournalEventMessage() {
    const date = dayjs(this.triggeringJournalEvent.occurredAt).format("DD/MM/YYYY");
    if (this.triggeringJournalEvent instanceof FileUploadedJournalEvent) {
      return `${date} - ${this.triggeringJournalEvent.title}`;
    }
    return date;
  }
  get triggeringJournalEventIsPrescription() {
    return this.triggeringJournalEvent instanceof BioExamPrescribedJournalEvent || this.triggeringJournalEvent instanceof MedicationPrescribedJournalEvent || this.triggeringJournalEvent instanceof MedicalImagingPrescribedJournalEvent || this.triggeringJournalEvent instanceof ParamedicalCarePrescribedJournalEvent;
  }
  get prescriptionComponent() {
    return getPrescriptionJournalEventComponent(this.triggeringJournalEvent);
  }
  get prescriptionRoute() {
    if (this.session.medic) {
      return `medics-web.protected.patients.patient.prescriptions.${this.prescriptionComponent}`;
    }
    return `patient-web.protected.prescriptions.${this.prescriptionComponent}`;
  }
  get interlocutorType() {
    if (!this.creator) {
      return ChatMessageInterlocutor.Recipient;
    }
    if (this.isMessageSentByMedic && this.session.medic?.id == this.creator.id) {
      return ChatMessageInterlocutor.Sender;
    } else if (this.isMessageSentByPatient && this.session.patient?.id == this.creator.id) {
      return ChatMessageInterlocutor.Sender;
    } else if (this.isMessageSentByMedic && this.session.medic) {
      return ChatMessageInterlocutor.Recipient_Alternate;
    }
    return ChatMessageInterlocutor.Recipient;
  }
  get shouldShowUnreadMessage() {
    return this.args.lastMessage && !!this.session.medic && !this.session.medic.disabledNotificationTypes?.includes("PatientChatMessageSentJournalEvent") && this.isMessageSentByPatient && (this.args.messageEvent.notificationTriggeredJournalEvents.length == 0 || this.args.messageEvent.notificationTriggeredJournalEvents.every(je => je.hasBeenProcessed));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ChatMessageFeedMessageComponent as default };